import { render, staticRenderFns } from "./StockRheader.vue?vue&type=template&id=c7f971cc&scoped=true&"
import script from "./StockRheader.vue?vue&type=script&lang=js&"
export * from "./StockRheader.vue?vue&type=script&lang=js&"
import style0 from "./StockRheader.vue?vue&type=style&index=0&id=c7f971cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f971cc",
  null
  
)

export default component.exports